import { CreditCard, Printer, Zap } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const STEPS = [
  {
    icon: CreditCard,
    num: "01",
    title: "Secure Square Checkout",
    body: "One-time payment on Square's encrypted checkout. No account to create, no subscription to cancel, no card data touches our servers.",
    testid: "step-delivery-1",
  },
  {
    icon: Zap,
    num: "02",
    title: "Instant Download Page",
    body: "The moment payment confirms, your confirmation page unlocks every file in your kit — individually or as one ZIP. Delivery in under 60 seconds.",
    testid: "step-delivery-2",
  },
  {
    icon: Printer,
    num: "03",
    title: "Print It. Use It Today.",
    body: "PDFs print clean on any shop printer; the Excel calculator opens in Excel or Google Sheets. Edit the wording, add your logo, put it on the counter.",
    testid: "step-delivery-3",
  },
];

export default function Delivery() {
  return (
    <section id="delivery" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          overline="Fulfillment // Instant Digital Delivery"
          title="From checkout to clipboard in under a minute"
          align="center"
        />
        <div className="mt-16 grid md:grid-cols-3 gap-5 relative">
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-blaze/40 to-transparent" />
          {STEPS.map((s, i) => (
            <Reveal key={s.testid} delay={i * 0.14}>
              <div data-testid={s.testid} className="relative border border-slate-400/10 bg-panel p-8 h-full transition-colors duration-200 hover:border-blaze/40">
                <div className="flex items-center justify-between">
                  <s.icon className="w-7 h-7 text-blaze" />
                  <span className="font-mono font-bold tracking-tighter text-4xl text-slate-700">{s.num}</span>
                </div>
                <h3 className="mt-6 font-display text-xl font-bold uppercase tracking-tight text-slate-50">{s.title}</h3>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
